import {
  QUERY_CONSTANTS,
} from './QueryConstants';

const {
  TYPES,
} = QUERY_CONSTANTS;

const BOOKMARK_ENTITY_TYPES = {
  COMPANY: 2,
  CONTACT: 1,
};

const ENTITY_TYPES = {
  COMPANY: 'company',
  CONTACT: 'contact',
};

const LIST_SOURCES = {
  PARAMETERIZED: 'parameterized',
  QUERY: 'query',
};

const COMPANY_QUERY_TYPE_ID_LIST = [
  TYPES.PROSPECTING_ACCOUNT,
  TYPES.CONSULTED_ACCOUNT,
  TYPES.EXPORTED_ACCOUNT,
  TYPES.EXPORT_CRM_COMPANIES,
  TYPES.LINKEDIN_CONSULTED_ACCOUNT,
  TYPES.AVOID_COMPANY,
];

const CONTACT_QUERY_TYPE_ID_LIST = [
  TYPES.PROSPECTING_CONTACT,
  TYPES.ENGAGED_CONTACT,
  TYPES.CONSULTED_CONTACT,
  TYPES.EXPORTED_CONTACT,
  TYPES.CAMPAIGN_QUERY_NPAI,
  TYPES.CAMPAIGN_QUERY_SOFT,
  TYPES.CAMPAIGN_QUERY_OVERQUOTA,
  TYPES.CAMPAIGN_QUERY_OPENERS,
  TYPES.CAMPAIGN_QUERY_UNSUBSCRIBERS,
  TYPES.CAMPAIGN_QUERY_CLICKERS,
  TYPES.CAMPAIGN_QUERY_INACTIVES,
  TYPES.CAMPAIGN_QUERY_TARGETS,
  TYPES.CAMPAIGN_QUERY_OPENERS_NOT_CLICKERS,
  TYPES.CAMPAIGN_QUERY_HARD_BOUNCE,
  TYPES.INTERACTION_MAIL_SEND,
  TYPES.INTERACTION_CALLED,
  TYPES.INTERACTION_MAIL_OPENED,
  TYPES.INTERACTION_MAIL_CLICKED,
  TYPES.STATUS_ENGAGED_CONTACT,
  TYPES.STATUS_INTERESTED_CONTACT,
  TYPES.INTERACTION_APPOINTMENT,
  TYPES.INTERACTION_NO_POTENTIAL,
  TYPES.PUSH_TO_CRM,
  TYPES.INTERACTION_MAIL_REPLIED,
  TYPES.INTERACTION_MAIL_BOUNCED,
  TYPES.IGNORE_ALL_CONTACT_LIST,
  TYPES.IGNORE_ENGAGE_CONTACT_LIST,
  TYPES.IGNORE_CAMPAIGN_CONTACT_LIST,
  TYPES.IGNORE_CUSTOM_CONTACT_LIST,
  TYPES.SEQUENCE_TARGETS,
  TYPES.SEQUENCE_OPENERS,
  TYPES.SEQUENCE_CLICKERS,
  TYPES.SEQUENCE_REPLIED,
  TYPES.CONSULTED_MOBILE_ORGANIZATION,
  TYPES.SPAM_COMPLAINT,
  TYPES.LINKEDIN_CONSULTED_CONTACT,
  TYPES.INTERACTION_MAIL_AUTOREPLIED,
  TYPES.INTERACTION_MAIL_BLOCKED,
  TYPES.LINKEDIN_INVITATION_SENT,
  TYPES.LINKEDIN_MESSAGE_SENT,
];

const INFO_POPUP_STORAGE_KEY = 'ls.mylistspopup';
const INFO_POPUP_STORAGE_KEY_FALLBACK = 'mylistspopup';
const LIMIT = 10;

const AUTOMATIC_ACTION_QUERY_TYPE_ID_LIST = [
  TYPES.ENGAGED_CONTACT,
  TYPES.CONSULTED_CONTACT,
  TYPES.CONSULTED_ACCOUNT,
  TYPES.INTERACTION_MAIL_SEND,
  TYPES.INTERACTION_CALLED,
  TYPES.INTERACTION_APPOINTMENT,
  TYPES.INTERACTION_NO_POTENTIAL,
  TYPES.PUSH_TO_CRM,
  TYPES.LINKEDIN_CONSULTED_CONTACT,
  TYPES.LINKEDIN_CONSULTED_ACCOUNT,
  TYPES.LINKEDIN_INVITATION_SENT,
  TYPES.LINKEDIN_MESSAGE_SENT,
  TYPES.AVOID_COMPANY,
];

const QUERY_TYPE_ID_LIST_BY_CATEGORY = {
  CONTACTS: [
    TYPES.PROSPECTING_CONTACT,
  ],
  COMPANIES: [
    TYPES.PROSPECTING_ACCOUNT,
  ],
  AUTOMATIC: [
    TYPES.CONSULTED_CONTACT,
    TYPES.EXPORTED_CONTACT,
    TYPES.CONSULTED_ACCOUNT,
    TYPES.INTERACTION_MAIL_SEND,
    TYPES.INTERACTION_CALLED,
    TYPES.INTERACTION_APPOINTMENT,
    TYPES.INTERACTION_NO_POTENTIAL,
    TYPES.PUSH_TO_CRM,
    TYPES.LINKEDIN_CONSULTED_CONTACT,
    TYPES.LINKEDIN_CONSULTED_ACCOUNT,
    TYPES.LINKEDIN_INVITATION_SENT,
    TYPES.LINKEDIN_MESSAGE_SENT,
    TYPES.AVOID_COMPANY,
  ],
  UNSUBSCRIBED: [
    TYPES.IGNORE_ALL_CONTACT_LIST,
    TYPES.IGNORE_ENGAGE_CONTACT_LIST,
    TYPES.IGNORE_CAMPAIGN_CONTACT_LIST,
    TYPES.IGNORE_CUSTOM_CONTACT_LIST,
  ],
};

const VIEW_LIST = {
  COMPANY: 'view_list_company',
  CONTACT: 'view_list_contact',
};

const MY_LIST_CONSTANTS = {
  AUTOMATIC_ACTION_QUERY_TYPE_ID_LIST,
  BOOKMARK_ENTITY_TYPES,
  COMPANY_QUERY_TYPE_ID_LIST,
  CONTACT_QUERY_TYPE_ID_LIST,
  ENTITY_TYPES,
  INFO_POPUP_STORAGE_KEY,
  INFO_POPUP_STORAGE_KEY_FALLBACK,
  LIMIT,
  LIST_SOURCES,
  QUERY_TYPE_ID_LIST_BY_CATEGORY,
  VIEW_LIST,
};

export {
  MY_LIST_CONSTANTS,
};
